import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function usePostFinish({ token }) {
  const mutation = useMutation({
    mutationKey: ['finish-simulation', token],
    mutationFn: async (params) => {
      const data = await handleFetchResponse(
        fetch(getApiUrl('energia-solar/v2/simulation/finish'), {
          method: 'POST',
          body: JSON.stringify(params),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
